import { Store } from '@ngxs/store';
import { defer, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { getLoadedResults, ignoreNullish, Loadable, Logger } from '@aiwyn/shared';

import { ClientIdentityType } from '../utility';
import { TypedIdentity } from '../models';
import { CommonClientRequestsState } from '../state';

import { AbstractBaseCommonClientRequestController } from './abstract-base-common-client-request-controller.model';
import { BaseClient } from '@aiwyn/api';

export class BaseCommonClientRequestClient<
  Client extends BaseClient = BaseClient,
  ClientTypeClass extends CommonClientModelToClassMap<Client> = CommonClientModelToClassMap<Client>,
> extends AbstractBaseCommonClientRequestController<TypedIdentity<ClientIdentityType>, Client, ClientTypeClass> {

  readonly model$: Observable<Loadable<Client>> = defer(() =>
    this._store.select(CommonClientRequestsState.getClientLoadable(this.identity)),
  ).pipe(
    ignoreNullish(),
  ) as Observable<Loadable<Client>>;

  protected _create$(
    model$: Observable<Loadable<Client>>,
    store: Store,
    logger: Logger,
  ): Observable<ClientTypeClass> {
    return getLoadedResults(model$).pipe(
      map(_ => new CommonClientRequestClient(model$, store, logger) as ClientTypeClass),
    );
  }
}

abstract class AbstractCommonClientRequestClient<
  Client extends BaseClient = BaseClient,
> {
  constructor(
    protected readonly model$: Observable<Loadable<Client>>,
    protected readonly _store: Store,
    protected readonly _logger: Logger,
  ) {}

  abstract name$: Observable<string>;
}

export class CommonClientRequestClient extends AbstractCommonClientRequestClient {
  name$ = this.model$.pipe(
    map(({ data }) => data.name),
  );
}

export type CommonClientModelToClassMap<Client extends BaseClient> =
  Client extends BaseClient ? CommonClientRequestClient : never;
